import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "user-register",
  props: ["title", "value", "trialSheets"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      data: {
        status: "已通过",
        remark: ""
      },
      rules: {
        status: {
          type: "string",
          required: true
        },
        remark: {
          type: "string",
          required: true
        }
      },
      loading: false
    };
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;
      var data = this.data;
      var ids = this.trialSheets.map(function (t) {
        return t.id;
      });
      this.loading = true;
      return Axios.post("trials/".concat(ids[0], "/review/"), {
        action: data.status,
        remark: data.remark
      }).then(function () {
        return _this.loading = false;
      }, function (e) {
        _this.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    }
  }
};